import { UserAppsPage } from '@/features/user/apps/apps-page'

export function HomePage() {
  return <UserAppsPage />
}
